<small class="debug">{{me}}</small>
<div class="playlist_properties">
  <app-video-link style="position: fixed; top: -10px; width: 50px; height: 50px" videoLink="/help/YouTube"></app-video-link>
  <div class="clearFloat"></div>
  <div class="playlist_properties">
    @if (dynamicsInitialized) {
      <div>
        <dynamic-form
          [fields]="uiConfigInit"
          [ignoreValidation]="true"
          (submit)="submit($event)">
        </dynamic-form>
      </div>
    }
  </div>
</div>
